import React, { useEffect } from 'react'
import { useRequest } from 'hooks/useRequest';
import useScript from 'utils/ScriptConvert';
import LoaderTwo from 'pages/LoaderTwo';
import auth from 'utils/Auth';
import { stages } from 'utils/Constants';
import { useNavigate } from 'react-router-dom';

const StageWithoutRegister = ({ setRegisterState }) => {

  const [request,loading] = useRequest()
  const navigate = useNavigate();

  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA

  useEffect(()=>{
    if(auth.isHaveToken()){
      return navigate('/')
    }
    useScript(`https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`).then(() => {
      window.grecaptcha.ready(function() {
        window.grecaptcha.execute(recaptchaSiteKey, {action: 'submit'}).then(function(token) {
          request('/InternalAuth/GuestRegister', {
            method: 'POST',
            data: {
              token: token,
            },
          }).then((res) => {
              if (res.data.result) {
                auth.setGuestToken(res.data.result)
                localStorage.setItem('isGuest',JSON.stringify(true))
                setRegisterState(stages.STAGE_TYPE_SELECTION)
              } else {
                navigate('/')
              }
          })
          })})
    })
   },[])


  return (

    <div className='register-container'>
      <LoaderTwo isDataLoading={loading} />
    </div>
  )
}

export default StageWithoutRegister